import { add as addTime, isBefore, isEqual } from 'date-fns';

import { Activity } from '@bizzabo/entities';
import { TimeSlot } from '../../types';

const sessionsEndsMiddleMeetingHandle = ({ startMeetingTime, endMeetingTime, activity }) => {
    return (
        isBefore(startMeetingTime, activity.endDateUTCTimestamp) &&
        isBefore(activity.endDateUTCTimestamp, endMeetingTime)
    );
};

const sessionsStartsMiddleMeetingHandle = ({ startMeetingTime, endMeetingTime, activity }) => {
    return (
        isBefore(startMeetingTime, activity.startDateUTCTimestamp) &&
        isBefore(activity.startDateUTCTimestamp, endMeetingTime)
    );
};

const sessionsStartBeforeMeetingEndAfterHandle = ({
    startMeetingTime,
    endMeetingTime,
    activity,
}) => {
    return (
        (isBefore(activity.startDateUTCTimestamp, startMeetingTime) ||
            isEqual(activity.startDateUTCTimestamp, startMeetingTime)) &&
        (isBefore(endMeetingTime, activity.endDateUTCTimestamp) ||
            isEqual(endMeetingTime, activity.endDateUTCTimestamp))
    );
};

const overlapSessionsHandle = ({ startMeetingTime, endMeetingTime, activities }) => {
    return activities.filter((activity: Activity) => {
        return (
            sessionsEndsMiddleMeetingHandle({ startMeetingTime, endMeetingTime, activity }) ||
            sessionsStartsMiddleMeetingHandle({ startMeetingTime, endMeetingTime, activity }) ||
            sessionsStartBeforeMeetingEndAfterHandle({ startMeetingTime, endMeetingTime, activity })
        );
    });
};

export const calculateOverlapTimes = (
    datesTime: TimeSlot[] = [],
    duration: number,
    activities: Activity[]
) => {
    const durationMinutes = Math.floor(duration / (1000 * 60));
    return datesTime.map(dateTime => {
        const endMeetingTime = addTime(dateTime.time, { minutes: durationMinutes });

        const overlapSessions = overlapSessionsHandle({
            startMeetingTime: dateTime.time,
            endMeetingTime,
            activities,
        });

        return {
            ...dateTime,
            overlapSessions,
        };
    });
};
